/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { SidebarComponent } from 'src/app/@amiga-pyme/class/sidebar.class';
import {
  CartPurchaseOrderService,
  TypeAddCart
} from '../../utils-components/cart/cart-purchase-order.service';

@Component({
  selector: 'pg-products-provider-sidebar',
  templateUrl: './products-provider-sidebar.component.html',
  providers: [MessageService]
})
export class ProductsProviderSidebarComponent extends SidebarComponent {
  @Input() type: TypeAddCart;
  @Input() items;
  @Input() itemReception: boolean;
  @Input() itemInvoice: boolean;
  itemStock: { label: string; value: string }[];
  settings = {
    title: null,
    tooltip: null
  };
  netTotal: number;
  tax: number;
  totalTax: number;
  grossTotal: number;
  quantity: number;
  unitPrice: number;
  discount: number;
  fieldsStock;
  quantityMax: number;
  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private cartPurchaseOrderService: CartPurchaseOrderService
  ) {
    super('Producto SideBar Stock');
  }

  ngOnChanges() {
    this.setSettings();
    this.setItemInSideBar();
    const quantity = this.item?.quantity ? this.item.quantity : 0;
    const quantity_received = this.item?.quantity_received
      ? this.item.quantity_received
      : 0;
    const quantity_invoiced = this.item?.quantity_invoiced
      ? this.item.quantity_invoiced
      : 0;
    const unitPrice = this.item?.unitPrice ? this.item.unitPrice : 0;
    const discount = this.item?.discount ? this.item.discount : 0;
    const lot = this.item?.lot ? this.item.lot : '';
    const expDate = this.item?.expDate ? this.item.expDate : '';

    if (this.itemReception) {
      if (this.type === 'new') {
        this.quantityMax = quantity - quantity_received;
        this.fg = this.fb.group({
          quantity_cart: [
            0,
            [
              Validators.required,
              Validators.min(1),
              Validators.max(quantity - quantity_received)
            ]
          ],
          lot: [lot, [Validators.required]],
          expDate: [expDate, [Validators.required]]
        });
      } else if (this.type === 'update') {
        this.quantityMax = quantity - quantity_received;
        this.fg = this.fb.group({
          quantity_cart: [
            0,
            [
              Validators.required,
              Validators.min(1),
              Validators.max(quantity - quantity_received)
            ]
          ],
          lot: [lot, [Validators.required]],
          expDate: [expDate, [Validators.required]]
        });
      }
    } else {
      if (this.itemInvoice) {
        if (this.type === 'new') {
          this.quantityMax = quantity - quantity_invoiced;
          this.fg = this.fb.group({
            quantity_cart: [
              0,
              [
                Validators.required,
                Validators.min(1),
                Validators.max(quantity - quantity_invoiced)
              ]
            ]
          });
        } else if (this.type === 'update') {
          this.quantityMax = quantity - quantity_invoiced;
          this.fg = this.fb.group({
            quantity_cart: [
              0,
              [
                Validators.required,
                Validators.min(1),
                Validators.max(quantity - quantity_invoiced)
              ]
            ]
          });
        }
      } else {
        this.fg = this.fb.group({
          quantity: [quantity, [Validators.required, Validators.min(1)]],
          unitPrice: [unitPrice, [Validators.required, Validators.min(0)]],
          discount: [discount, [Validators.required, Validators.min(0)]]
        });
      }
    }
  }

  onSubmit() {
    if (this.fg.valid) {
      this.item['netTotal'] = this.netTotal;
      this.item['tax'] = this.tax;
      this.item['totalTax'] = this.totalTax;
      this.item['grossTotal'] = this.grossTotal;
      const newItem = {
        ...this.item,
        ...this.fg.value
      };
      this.addItemIntoCart$(newItem, this.type);
    }
  }

  setSettings() {
    this.settings = {
      title: 'Agregar Producto',
      tooltip: 'Agregar al almacén'
    };

    if (this.type === 'new') {
      this.settings = {
        title: 'Agregar Producto al Carrito',
        tooltip: 'Agregar al carrito'
      };
    } else if (this.type === 'update') {
      this.settings = {
        title: 'Actualizar Producto del Carrito',
        tooltip: 'Actualizar el carrito'
      };
    }
  }

  addItemIntoCart$(data: any, type: TypeAddCart) {
    if (!data) return;
    if (type === 'new') {
      this.addNewItemCart(data);
    } else if (type === 'update') {
      this.updateItemCart(data);
    }
  }

  addNewItemCart(item) {
    if (this.itemReception) {
      const id = item.productOfProviderId;
      const existsItem = this.cartPurchaseOrderService.data[id];
      if (existsItem) {
        this.messageService.add({
          severity: 'warn',
          summary: 'El producto ya fue agregado',
          detail: 'Puedes modificar la cantidad en el carrito'
        });
        setTimeout(() => {
          this.close.emit();
        }, 2200);
        return;
      }
      this.cartPurchaseOrderService.addItemReception(item);
      this.messageService.add({
        severity: 'success',
        summary: 'Producto Agregado',
        detail: `${item.name}--${item.unitMeasure}`
      });
    } else {
      if (this.itemInvoice) {
        const id = item.productOfProviderId;
        const existsItem = this.cartPurchaseOrderService.data[id];
        if (existsItem) {
          this.messageService.add({
            severity: 'warn',
            summary: 'El producto ya fue agregado',
            detail: 'Puedes modificar la cantidad en el carrito'
          });
          setTimeout(() => {
            this.close.emit();
          }, 2200);
          return;
        }
        this.cartPurchaseOrderService.addItemReception(item);
        this.messageService.add({
          severity: 'success',
          summary: 'Producto Agregado',
          detail: `${item.name}--${item.unitMeasure}`
        });
      } else {
        const id = item.id;
        const existsItem = this.cartPurchaseOrderService.data[id];
        if (existsItem) {
          this.messageService.add({
            severity: 'warn',
            summary: 'El producto ya fue agregado',
            detail: 'Puedes modificar la cantidad en el carrito'
          });
          setTimeout(() => {
            this.close.emit();
          }, 2200);
          return;
        }
        this.cartPurchaseOrderService.addItem(item);
        this.messageService.add({
          severity: 'success',
          summary: 'Producto Agregado',
          detail: `${item.description}--${item.unitMeasureDescription}`
        });
      }
    }

    setTimeout(() => {
      this.close.emit();
    }, 1200);
  }

  updateItemCart(item) {
    if (this.itemReception) {
      this.cartPurchaseOrderService.addItemReception(item);
      this.messageService.add({
        severity: 'success',
        summary: 'Producto Actualizado',
        detail: item.name
      });
    } else {
      if (this.itemInvoice) {
        this.cartPurchaseOrderService.addItemReception(item);
        this.messageService.add({
          severity: 'success',
          summary: 'Producto Actualizado',
          detail: item.name
        });
      } else {
        this.cartPurchaseOrderService.addItem(item);
        this.messageService.add({
          severity: 'success',
          summary: 'Producto Actualizado',
          detail: item.name
        });
      }
    }
    setTimeout(() => {
      this.close.emit();
    }, 1200);
  }

  setItemInSideBar() {
    this.quantity = this.item?.quantity ? this.item.quantity : 0;
    this.unitPrice = this.item?.unitPrice ? this.item.unitPrice : 0;
    this.discount = this.item?.discount ? this.item.discount : 0;
    this.updateFields();

    if (this.itemReception || this.itemInvoice) {
      this.fieldsStock = {
        name: 'Descripción',
        unitMeasure: 'Unidad de medida',
        netTotal: 'Total Neto'
      };
    } else {
      this.fieldsStock = {
        description: 'Descripción',
        unitMeasureDescription: 'Unidad de medida'
      };
    }

    const keysStock = Object.keys(this.fieldsStock);
    this.itemStock = keysStock.map((key) => {
      return {
        label: this.fieldsStock[key],
        value: this.item[key]
      };
    });
  }

  onInputUnitPrice(event) {
    this.unitPrice = event.value;
    if (this.unitPrice < this.discount) {
      this.discount = this.unitPrice;
    }
    this.updateFields();
  }
  onInputQuantity(event) {
    this.quantity = event.value;
    this.updateFields();
  }
  onInputDiscount(event) {
    this.discount = event.value;
    this.updateFields();
  }

  updateFields() {
    this.tax = 0.18;
    const netTotalFloat = this.quantity * (this.unitPrice - this.discount);
    this.netTotal = Math.trunc(netTotalFloat * 100) / 100;
    const grossTotalFloat = this.netTotal / (1 + this.tax);
    this.grossTotal = Math.trunc(grossTotalFloat * 100) / 100;
    this.totalTax = Math.trunc((-this.grossTotal + this.netTotal) * 100) / 100;
  }
}
